import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const ConvertToAdmission = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const bookingId = searchParams.get('booking');
  
  // Redirect to StudentAdmission page which has full functionality including documents
  useEffect(() => {
    if (bookingId) {
      navigate(`/students/admission?booking=${bookingId}`, { replace: true });
    } else {
      navigate('/seat-booking/list', { replace: true });
    }
  }, [bookingId, navigate]);

  // Show loading while redirecting
  return (
    <div className="flex items-center justify-center h-64">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecting to Admission Form...</p>
      </div>
    </div>
  );
};

export default ConvertToAdmission;
